import {Component, OnDestroy, OnInit} from '@angular/core';
import {ProjectConstants} from '../../../project-constants';
import {FormBuilder, FormGroup, NgForm, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import * as toastr from 'toastr';
import {RateTypeModel} from '../../../../models/RateTypeModel';
import {RateTypeAnagrafService} from '../../../general-services/service-rate-type/rate-type-anagraf.service';
import {RoleAnagrafModel} from '../../../../models/RoleAnagrafModel';
import {RoleAnagrafService} from '../../../general-services/service-role-anagraf/role-anagraf.service';
import {RateTypeAnagrafComponent} from '../rate-type-anagraf.component';

@Component({
  selector: 'app-new-rate-type-anagraf',
  templateUrl: './new-rate-type-anagraf.component.html',
  styleUrls: ['./new-rate-type-anagraf.component.scss']
})
export class NewRateTypeAnagrafComponent  extends ProjectConstants implements OnInit, OnDestroy {
  rateTypeAnagraf: RateTypeModel;
  formValidator: FormGroup;
  formBuilder: FormBuilder;
  saveSubscribe: Subscription;

  constructor(private route: ActivatedRoute, private router: Router,
              private rateTypeAnagrafService: RateTypeAnagrafService) {
    super();

    this.rateTypeAnagraf = new RateTypeModel();

    this.formBuilder = new FormBuilder();

    this.formValidator = this.formBuilder.group({
      code: [this.rateTypeAnagraf.code, [Validators.required]],
      description: [this.rateTypeAnagraf.description, [Validators.required]]
    });
  }

  ngOnInit() {

  }

  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.ROLE_ANAGRF]);
  }

  save(event: any, form: NgForm, clickSalva ?: boolean) {
    if (event.key === 'Enter' || clickSalva) {
      event.preventDefault();
      this.rateTypeAnagraf.code = this.formValidator.value.code;
      this.rateTypeAnagraf.description = this.formValidator.value.description;
      this.saveSubscribe = this.rateTypeAnagrafService.save(this.rateTypeAnagrafService.baseUrl, this.rateTypeAnagraf).subscribe(
        (result: any) => {
          if (result === -1) {
            toastr.options.timeout = 5000;
            toastr.warning('Duplicate item, Role Cod already exists', 'Warning');
          } else {
            this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.RATE_TYPE__ANAGRF]);
          }
        });
    }
  }

  ngOnDestroy(): void {
    if (this.saveSubscribe) {
      this.saveSubscribe.unsubscribe();
    }
  }
}
